import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const tabIndicatorPropsDesktop = {
  style: {
    left: '0',
    width: '4px',
  },
};

export const emptyFiltersMessageSx: SxProps<Theme> = {
  m: '24px',
};

export const getFiltersRendererRootSx = (isMobile: boolean): SxProps<Theme> => ({
  flexGrow: 1,
  backgroundColor: 'background.paper',
  display: isMobile ? 'block' : 'flex',
});

export const getFiltersRendererTabsSx = (isMobile: boolean): SxProps<Theme> => ({
  minWidth: '200px',
  width: isMobile ? 'unset' : '411px',
  flexShrink: 0,
  position: 'relative',
  '& .tab': {
    minHeight: '57px',
    padding: 0,
    opacity: 1,
    maxWidth: 'unset',
    '& .MuiTab-wrapper': {
      alignItems: isMobile ? 'center' : 'flex-start',
      textTransform: 'none',
      fontWeight: 700,
      color: 'text.primary',
      fontSize: '1rem',
      lineHeight: 1.2,
      padding: isMobile ? '8px' : 0,
      marginLeft: isMobile ? 0 : '25px',
      '@media (max-width:400px)': {
        fontSize: '0.875rem',
      },
    },
    borderBottom: `1px solid ${Color.disabledGray}`,
    '&.Mui-selected': {
      borderRight: `1px solid ${Color.white}`,
    },
  },
  '&::before': {
    display: isMobile ? 'none' : 'block',
    content: '""',
    width: '1px',
    backgroundColor: Color.disabledGray,
    height: '9999px',
    top: 0,
    right: 0,
    position: 'absolute',
  },
});

export const filtersRendererPanelWrapperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  p: '20px',
};

export const filtersRendererGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  gap: '24px',
  gridAutoFlow: 'dense',
};
